import * as S from './styles'

export const ConsolidatedEntrySkeleton = () => {
  return (
    <>
      <S.HeaderCard>
        <S.HeaderTopRow>
          <S.Chip variant="rounded" width={90} height={22} />
          <S.Chip variant="rounded" width={110} height={22} />
        </S.HeaderTopRow>
        <S.TitleSkeleton variant="text" width={260} height={32} />
        <S.SubtitleSkeleton variant="text" width={380} height={20} />
      </S.HeaderCard>

      <S.GridCard>
        {Array.from({ length: 5 }).map((_, index) => (
          <S.GridRow key={index}>
            <S.GridLabel variant="text" width="35%" height={20} />
            <S.GridValue variant="text" width="15%" height={20} />
            <S.GridValue variant="text" width="15%" height={20} />
            <S.GridValue variant="text" width="15%" height={20} />
          </S.GridRow>
        ))}
      </S.GridCard>

      <S.InsertCard>
        <S.InsertTopRow>
          <S.TitleSkeleton variant="text" width={160} height={24} />
          <S.Chip variant="rounded" width={24} height={24} />
        </S.InsertTopRow>
        <S.SubtitleSkeleton variant="text" width="70%" height={18} />
      </S.InsertCard>
    </>
  )
}
